export interface DialogsState {
  [name: string]: boolean;
  data?: any;
}

export const dialogsState: DialogsState = {};
